import {NgModule}             from '@angular/core';
import {RouterModule, Routes} from '@angular/router';

import {LoginComponent} from './login/index';
import {SearchComponent} from './search/index';
import {AuthGuard} from './_guards/index';
import {AboutComponent} from "./about/about.component";
import {LogoutComponent} from "./logout/logout.component";
import {ContactComponent} from "./contact/contact.component";
import {NotFoundComponent} from "./error/404.component";
import {IndexComponent} from "./index/index.component";

const routes: Routes = [
    {path: '', component: IndexComponent},
    {path: 'login', component: LoginComponent},
    {path: 'about', component: AboutComponent},
    {path: 'contact', component: ContactComponent},
    {path: 'search', component: SearchComponent, canActivate: [AuthGuard]},
    {path: 'logout', component: LogoutComponent},
    {path: '404', component: NotFoundComponent},
    {path: '**', redirectTo: '/404'}
];

@NgModule({
    imports: [RouterModule.forRoot(routes)],
    exports: [RouterModule]
})
export class AppRoutingModule {
}



// WEBPACK FOOTER //
// /home/gitlab-runner/builds/odQvAFzU/0/heba/118365/src/main/frontend/src/app/app-routing.module.ts